import {booleanAttribute, ChangeDetectionStrategy, Component, computed, inject, input, output,} from "@angular/core";
import {CommonModule} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {ArticleInfos} from "../../../features/articles/models/article.model";
import {ArticlesInfosFacadeService} from "../../../features/articles/services/article-infos/article-infos-facade.service";
import {DocLocalComponent} from "../../../features/documents/containers/doc-local/doc-local.component";
import {BioLogoComponent} from "../bio-logo/bio-logo.component";
import {PopoverModule} from "../../modules/popover/popover.module";
import {BigButtonComponent} from "../big-button/big-button.component";
import {ChipsComponent} from "../../modules/chips/chips.component";
import {SharedModule} from "../../shared.module";
import {Router} from "@angular/router";

@Component({
  selector: "vl-radio-card",
  standalone: true,
  imports: [CommonModule, MatIconModule, DocLocalComponent, BioLogoComponent, PopoverModule, BigButtonComponent, ChipsComponent, SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./radio-card.component.html",
  styleUrl: "./radio-card.component.scss",
  host: {
    "[class]": "hostClasses()",
  },
})
export class RadioCardComponent {
  private articlesFacade = inject(ArticlesInfosFacadeService);
  private router = inject(Router);

  // Inputs
  selected = input<boolean>(false);
  disabled = input<boolean, unknown>(false, { transform: booleanAttribute });
  icon = input<string | null>(null);
  title = input<string>();
  subtitle = input<string | null>(null);
  mode = input<"radio" | "display">("radio");

  color = input<"valid" | "warn" | "secondary" | "basic" | "error">();

  // Article mode inputs
  articleId = input<string | null>(null);
  articleInfos = input<ArticleInfos | null>(null);

  article = computed<ArticleInfos | null>(() => {
    if (this.articleId()) {
      return this.articlesFacade.getByArticleId(this.articleId())();
    }
    return this.articleInfos() ?? null;
  });

  resolvedTitle = computed(() => this.title() ?? this.article()?.denomination ?? '');
  resolvedSubtitle = computed(() => this.subtitle() ?? (this.article() ? this.article().code : null));

  showPopover = computed(() => this.mode() === 'display' && !!this.article());

  // Outputs
  select = output<void>();

  onSelect(): void {
    if (!this.disabled()) {
      this.select.emit();
    }
  }

  hostClasses = computed(() => {
    const classes: string[] = [];
    if (this.mode() === "display") classes.push("radio-card--display");
    if (this.selected() || this.disabled()) {
      return classes.join(" ");
    }
    if (this.color()) classes.push(`radio-card--${this.color()}`);
    return classes.join(" ");
  });

  onNavigate() {
    const art = this.article();
    if (art) {
      this.router.navigateByUrl(`/specification/id/${art.articleId}`);
    }
  }

  onStats() {
    const art = this.article();
    if (art) {
      this.articlesFacade.onStats(art.articleId);
    }
  }

  goToComptage() {
    const art = this.article();
    if (art) {
      this.router.navigate(['/articles/inventory'], {
        queryParams: { articleId: art.articleId },
      });
    }
  }

  onStock() {
    const art = this.article();
    if (art) {
      this.router.navigate(['/stock/id/'], {
        queryParams: { articleId: art.articleId },
      });
    }
  }
}
